import { Injectable } from '@angular/core';

declare var staticValues: any;

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  getDefaultLang(): string {
    return 'es';
  }
  getLocale(): string {
    // used in TranslateService@ngx-translate/core
    // format should be lang_SITE, ex: es_UY, pt_BR
    return `${this.getLanguage()}_${this.getSite()}`;
  }
  getSorting(): string {
    return staticValues.defaultSorting;
  }
  getChannel(): string {
    return staticValues.channel;
  }
  public getLanguage(): string {
    return staticValues.language;
  }
  getSite(): string {
    return staticValues.home;
  }
  isWebview(): boolean {
    return staticValues.isWebview;
  }
  isLoyaltyEnabled(): boolean {
    return staticValues.isLoyaltyEnabled;
  }
  getPageViewId(): string {
    return staticValues.pageViewId;
  }
  getUserId(): string {
    return staticValues.userId;
  }
  getProduct(): string {
    return 'transfers';
  }
  getAppName(): string {
    return 's-transfers';
  }
  getFlow(): string {
    return 'search';
  }
  getFlowType(): string {
    return 'shopping';
  }
  isProviderFeatureEnabled(): boolean {
    return staticValues.providerFeatureEnabled;
  }

  isTransferSupplierFeatureEnabled(): boolean {
    return staticValues.transferSupplierFeatureEnabled;
  }

  getUow(): string {
    return staticValues.uow;
  }
  getThousandSeparator(): string {
    return staticValues.thousandsSymbol;
  }
  getCompanyId(): string {
    return staticValues.companyId;
  }
  getIsLogged(): string {
    return staticValues.isLogged;
  }
  constructor() { }
}


/*
  TODO load i18n for current site
  current setup doesn't work for pt_BR

  AR: https://www.despegar.com.ar
  BR: https://www.decolar.com
  CL: https://www.despegar.cl
  MX: https://www.despegar.com.mx
  CO: https://www.despegar.com.co
  CR: https://www.despegar.co.cr
  EC: https://www.despegar.com.ec
  US: https://www.us.despegar.com
  PE: https://www.despegar.com.pe
  PA: https://www.despegar.com.pa
  VE: https://www.despegar.com.ve
  UY: https://www.despegar.com.uy
  PY: https://www.despegar.com.py
*/
